import { ChangeEvent } from "react";

// Changing user password
export const CHANGE_PASSWORD_REQUEST =
  "bonfire/profile/CHANGE_PASSWORD_REQUEST";
interface ChangePasswordRequestAction {
  type: typeof CHANGE_PASSWORD_REQUEST;
}

export const CHANGE_PASSWORD = "bonfire/profile/CHANGE_PASSWORD";
interface ChangePasswordAction {
  type: typeof CHANGE_PASSWORD;
}

export const CHANGE_PASSWORD_SUCCESS =
  "bonfire/profile/CHANGE_PASSWORD_SUCCESS";
interface ChangePasswordSuccessAction {
  type: typeof CHANGE_PASSWORD_SUCCESS;
}

export const CHANGE_PASSWORD_FAIL = "bonfire/profile/CHANGE_PASSWORD_FAIL";
interface ChangePasswordFailAction {
  type: typeof CHANGE_PASSWORD_FAIL;
  error: any; // @TODO
}

// GUI CONTROL
export const CHANGING_PASSWORD = "bonfire/profile/CHANGING_PASSWORD";
interface ChangingPasswordAction {
  type: typeof CHANGING_PASSWORD;
}

export const END_ACTION = "bonfire/profile/END_ACTION";
interface EndActionAction {
  type: typeof END_ACTION;
}

export const EDITING_PROFILE_FORM = "bonfire/profile/EDITING_PROFILE_FORM";
interface EditingProfileFormAction {
  type: typeof EDITING_PROFILE_FORM;
  input_id: string;
  input_value: string | boolean | ChangeEvent<HTMLInputElement>;
}

export const VALIDATE_FORM_ERROR = "bonfire/profile/VALIDATE_FORM_ERROR";
interface ValidateFormErrorAction {
  type: typeof VALIDATE_FORM_ERROR;
  error: any; // @TODO
}

export type ProfileAction =
  | ChangePasswordAction
  | ChangePasswordFailAction
  | ChangePasswordRequestAction
  | ChangePasswordSuccessAction
  | ChangingPasswordAction
  | EditingProfileFormAction
  | EndActionAction
  | ValidateFormErrorAction;
